import { render, staticRenderFns } from "./EditAgent.vue?vue&type=template&id=05473594&"
import script from "./EditAgent.vue?vue&type=script&lang=js&"
export * from "./EditAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports